module.exports = __webpack_public_path__ + "aa4228d62ef2acfeef6d07fe51e04ac4.svg";